var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",style:(_vm.getStyle),attrs:{"type":"text"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }